"use strict";
(self["webpackChunkbranch_basics"] = self["webpackChunkbranch_basics"] || []).push([[8157],{

/***/ 8157:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ BlogSearch)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);


function BlogSearch({ wrapper }) {
  let $wrapper = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper)
  const settings = {
    gridWrapper: '[data-hook="post-grid-wrapper"]',


    searchResultsWrapper: '[data-hook="search-results-wrapper"]',
    searchTitle: '[data-hook="search-title"]',
    searchResults: '[data-hook="search-results"]',
    searchForm: '[data-hook="blog-search-form"]',
    
    noResultsWrapper: '[data-hook="no-results-wrapper"]',
    blogFilterWrapper: '[data-hook="blog-filter-wrapper"]',

    pageTitles: ["School Guide", "User Guide", "Pesticide Guide", "Cleaning Product Red Flags"],
  }

  const $config = {
    $blogFilterContainer: $wrapper.find(settings.blogFilterContainer)
  }

  const pageImages = {
    "School Guide": "https://cdn.shopify.com/s/files/1/0410/9100/6628/files/SchoolGuide_200x.jpg?v=1613681408",
    "Branch Basics User Guide": "https://cdn.shopify.com/s/files/1/0410/9100/6628/files/UserGuide_b8acf32c-8178-446e-a510-7b3ff55fd316_200x.jpg?v=1613681408",
    "Pesticide Guide": "https://cdn.shopify.com/s/files/1/0410/9100/6628/files/PesticideGuide_200x.jpg?v=1613681408",
    "Cleaning Product Red Flags": "https://cdn.shopify.com/s/files/1/0410/9100/6628/files/Cleaning_Product_Red_Flags_200x.jpg?v=1613681408"
  }

  let $gridWrappers = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.gridWrapper);
  let $searchResultsWrapper = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.searchResultsWrapper);

  let lastVal = "";

  ;(function init(){    
    if ($wrapper.length === 0) return;
    initBlogSearch();
  })()

  
  function initBlogSearch() {
    // Search Listeners
    $wrapper.on('keyup change', searchForPosts);
    $wrapper.on('submit', settings.searchForm, function(e){
      e.preventDefault();
    })
  }


  async function searchForPosts(e) {
    let $this = $wrapper;
    let searchVal = $this.val();

    if (searchVal !== lastVal) {
      lastVal = searchVal;
      try {
        let searchResults = await getSearchResults(searchVal);
      } catch(error) {
        console.log("error => ", error)
      }

    } else if (searchVal === "") {
      renderOriginalState();
    }
  }


  async function getSearchResults(searchVal) {
    let url = "/search/suggest.json?q=" + searchVal + "&resources[type]=article,page,query&resources[fields]=title,body,author,tag&resources[limit]=10&resources[limit_scope]=each"

    if (searchVal) {
      jquery__WEBPACK_IMPORTED_MODULE_0___default().ajax(url).then(function(res){
        console.log("getSearchResults -> res: ", res)

        if (res && res.resources && res.resources.results) {
          var articles = res.resources.results.articles;
          var pages = res.resources.results.pages.filter(function(page){
            return settings.pageTitles.find(function(title){
              return page.title.includes(title)
            })
          })

          pages.forEach(function(page, index){
            page.tags = ["PDF"]
            articles.splice(index + 1, 0, page);
          })
        }


        if (articles && articles.length > 0) {
          $gridWrappers.hide()
          jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.noResultsWrapper).hide()
          
          if (location.pathname.includes("wellness-center")) {
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.searchTitle).text("Results for: " + searchVal);
            var articlesHTML = articles.map((article,index)=>renderArticleTemplate(article,index,'related')).join("");
            
          } else {
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.searchTitle).text("Showing " + articles.length + " results for \"" + searchVal + '"').show();
            $config.$blogFilterContainer.hide();
            var articlesHTML = articles.map((article,index)=>renderArticleTemplate(article,index,'default')).join("");
          }

          jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.searchResults).html(articlesHTML);
          $searchResultsWrapper.show()

          console.log("articles: ", articles)
          console.log("articles.length: ", articles.length)


        } else {
          renderNoResults();
        }
      }).catch(renderNoResults);

    } else {
      renderOriginalState();
    }
  }


  function renderNoResults() {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.noResultsWrapper).show()
    $gridWrappers.show()
  }


  function renderOriginalState() {
    $searchResultsWrapper.hide()
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.noResultsWrapper).hide()
    $gridWrappers.show()

    $wrapper.val('');

    if (!location.pathname.includes("wellness-center")) {
      $config.$blogFilterContainer.show();
    } 
  }


  function renderArticleTemplate(article, index, type){
    let delay = screen.availWidth > 767 ? index % 3 * 100 : 0;
    let imageSrc = "";
    let imageDataSrc = "";

    if (article.image) {
      imageSrc = article.image.replace(/(\.[^.]*)$/, "_200x$1").replace('http:', '');
      imageDataSrc = article.image.replace(/(\.[^.]*)$/, "_500x$1").replace('http:', '');
    } else {
      imageSrc = pageImages[article.title];
      if (imageSrc) {
        imageDataSrc = imageSrc.replace("_200x", "_500x")
      } else {
        imageSrc = "https://cdn.shopify.com/s/files/1/0410/9100/6628/files/BB_Referral_2-05_c28e4716-ee83-460e-aced-a6266413868e_222x.png?v=1601498999";
        imageDataSrc = "https://cdn.shopify.com/s/files/1/0410/9100/6628/files/BB_Referral_2-05_c28e4716-ee83-460e-aced-a6266413868e_522x.png?v=1601498999";
      }
    }

    let extraClasses = index < 3 ? '' : ''
    let imageClasses = 'lazyload tw-w-full tw-h-[300px] md:tw-h-[175px] mg:tw-h-[300px] tw-object-cover'
    let subtitle = article.tags && article.tags.length ? article.tags[0] : ""
    
    let html;

    switch(type) {
      case 'default':
        html = `
        <li class="tw-flex tw-flex-col ${extraClasses}" data-delay="${delay}" data-tags="${article.tags}">
          <a href="${article.url}">
            <div class="tw-flex">
              <img data-src="${imageDataSrc}" data-sizes="auto" alt="${article.title}" class="${imageClasses}">
            </div>
            <div class="related-content ">
              <div class="small categories-title tw-uppercase">${subtitle}</div>
              <div class="h5 medium-up-only tw-delay-[400ms]">${article.title}</div>
              <h3 class="mobile-only tw-delay-[400ms]">${article.title}</h3>
            </div>
          </a>
        </li>`
        break

      case 'related':
        html = `
        <li class="tw-flex tw-flex-col ${extraClasses}" data-delay="${delay}">
          <a href="${article.url}">
            <div class="tw-flex">
              <img data-src="${imageDataSrc}" data-sizes="auto" alt="${article.title}" class="${imageClasses}">
            </div>
            <div class="related-content">
              <div class="small categories-title tw-uppercase">${subtitle}</div>
              <div class="h7 medium-up-only">${article.title}</div>
              <h5 class="mobile-only ">${article.title}</h5>
            </div>
          </a>
        </li>`
        break


      default:
        html = ``
        break
    }

    return html
  }


};

/***/ })

}]);